// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
export default {
  list(id) {
    // return firebaseAxios().then((axios) =>
    //   axios
    //     .get(`/categories/${id}/history`)
    //     .then((response) => response.data)
    // );
  }
};



// WEBPACK FOOTER //
// ./src/entities/category/category-history/category-history-single/category-history-single-service.js